export const normalizeTopProcedureData = results => {
	const topProcedures = Array.isArray(results) ? results : [];
	let largest = 100;

	topProcedures.forEach(procedure => {
		const total = Number(procedure && procedure.total);
		if (total > largest) {
			largest = total;
		}
	});

	return {
		topProcedures,
		ratioRange: 2 * largest
	};
};
